import { isAxiosError } from "axios";

export const isCabinetAccessDeniedError = (error: unknown) =>
  isAxiosError<{ code?: string }>(error) &&
  error.response?.status === 403 &&
  error.response.data?.code === "Cabinet.Disabled";
